import React from 'react';
import { motion } from 'framer-motion';
const IMGS = {
  sistema: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_1_Sistema_ML_Rentable_1_1.jpg?v=1777410950',
  tracker: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_2_Tracker_de_Stock_e_Inventario_1_1.jpg?v=1777410949',
  escalado: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_3_Sistema_de_Escalado_90_Dias_1_1.jpg?v=1777410950',
  bono1: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_4_Bono_1_Guia_5_Errores_1_1.jpg?v=1777410949',
  bono2: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_5_Bono_2_Pack_de_Plantillas_1_1.jpg?v=1777410950'
};
function SquareImg({
  src,
  alt
}: {
  src: string;
  alt: string;
}) {
  return <div style={{
    width: '100%',
    aspectRatio: '1 / 1',
    overflow: 'hidden'
  }} data-id="element-162">
      <img src={src} alt={alt} style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }} data-id="element-163" />
    </div>;
}
export function OfferSection() {
  return <section className="bg-navy-mid py-16 md:py-24" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-165">

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-166">
          <span className="text-teal font-semibold text-sm uppercase tracking-wider" data-id="element-167">
            Lo que recibís hoy
          </span>
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-white mt-3" data-id="element-168">
            El sistema completo para vendedores de Mercado Libre
          </h2>
        </motion.div>

        {/* FILA 1 — Producto principal (ancho 2/3) + 2 incluidos apilados (ancho 1/3) */}
        <div className="grid md:grid-cols-3 gap-4 mb-4" data-id="element-169">

          {/* Producto principal */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.55
        }} className="md:col-span-2 bg-navy-dark rounded-2xl overflow-hidden border border-gold/40 flex flex-col" data-id="element-170">
            <SquareImg src={IMGS.sistema} alt="Sistema ML Rentable" data-id="element-171" />
            <div className="p-6" data-id="element-172">
              <span className="inline-block bg-gold text-navy text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-173">
                PRODUCTO PRINCIPAL
              </span>
              <h3 className="font-display font-bold text-white text-xl md:text-2xl mb-1" data-id="element-174">
                Sistema ML Rentable
              </h3>
              <p className="text-white/45 text-sm mb-3" data-id="element-175">
                4 pestañas · Calculadora · Simulador · Dashboard
              </p>
              <span className="inline-block bg-gold/15 text-gold text-xs font-semibold px-3 py-1 rounded-full" data-id="element-176">
                Incluido en el Kit
              </span>
            </div>
          </motion.div>

          {/* Columna derecha: 2 incluidos apilados */}
          <div className="flex flex-col gap-4" data-id="element-177">
            {[{
            img: IMGS.tracker,
            name: 'Tracker de Stock e Inventario',
            tagline: 'Semáforo automático · Capital · Reposición'
          }, {
            img: IMGS.escalado,
            name: 'Sistema de Escalado 90 Días',
            tagline: 'Proyección · Plan semanal · Selector de productos'
          }].map((p, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1 + i * 0.08
          }} className="bg-navy-dark rounded-2xl overflow-hidden border border-white/10 flex flex-col flex-1" data-id="element-178">
                <SquareImg src={p.img} alt={p.name} data-id="element-179" />
                <div className="p-4" data-id="element-180">
                  <span className="inline-block bg-white/10 text-white/70 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-181">
                    INCLUIDO
                  </span>
                  <h3 className="font-display font-bold text-white text-base md:text-lg mb-1" data-id="element-182">{p.name}</h3>
                  <p className="text-white/40 text-xs" data-id="element-183">{p.tagline}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* FILA 2 — 2 bonos en horizontal: imagen cuadrada + texto al lado */}
        <div className="grid md:grid-cols-2 gap-4" data-id="element-184">
          {[{
          img: IMGS.bono1,
          name: 'Guía de los 5 Errores ML',
          tagline: 'PDF profesional · 20+ páginas',
          valor: 'Valor $19.900'
        }, {
          img: IMGS.bono2,
          name: 'Pack de Plantillas ML',
          tagline: '10 títulos · 5 descripciones · Checklist',
          valor: 'Valor $14.900'
        }].map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2 + i * 0.08
        }} className="bg-navy-dark rounded-2xl overflow-hidden border border-teal/30 flex flex-row" data-id="element-185">
              {/* Imagen cuadrada fija a la izquierda */}
              <div className="flex-shrink-0 w-36 md:w-48" style={{
            aspectRatio: '1 / 1',
            overflow: 'hidden'
          }} data-id="element-186">
                <img src={p.img} alt={p.name} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block'
            }} data-id="element-187" />
              </div>

              {/* Texto a la derecha */}
              <div className="p-5 flex flex-col justify-center gap-1" data-id="element-188">
                <span className="inline-block bg-teal/20 text-teal text-xs font-bold px-3 py-1 rounded-full self-start" data-id="element-189">
                  🎁 BONO GRATIS
                </span>
                <h3 className="font-display font-bold text-white text-base md:text-lg" data-id="element-190">{p.name}</h3>
                <p className="text-white/40 text-xs" data-id="element-191">{p.tagline}</p>
                <span className="text-white/25 text-xs line-through" data-id="element-192">{p.valor}</span>
              </div>
            </motion.div>)}
        </div>

      </div>
    </section>;
}